import { render, staticRenderFns } from "./leverage-margin.vue?vue&type=template&id=6c7b3fc7&scoped=true"
import script from "./leverage-margin.vue?vue&type=script&lang=js"
export * from "./leverage-margin.vue?vue&type=script&lang=js"
import style0 from "./leverage-margin.vue?vue&type=style&index=0&id=6c7b3fc7&prod&scoped=true&lang=css"
import style1 from "./leverage-margin.vue?vue&type=style&index=1&id=6c7b3fc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7b3fc7",
  null
  
)

export default component.exports